import React, { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { canadaGibsonFont } from "../Config";

export default function RHFAutoAddressField({
    name,
    control,
    defaultValue = "",
    errors,
    options = { componentRestrictions: { country: ["au"] } },
    disabled = false,
    ...muiProps
}) {
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const onChangeRef = useRef(() => {});
    const [lastSelectedAddress, setLastSelectedAddress] = useState("");

    const fieldError = name.split(".").reduce((obj, key) => obj?.[key], errors);

    useEffect(() => {
        if (!window.google || !window.google.maps || !window.google.maps.places || !inputRef.current) {
            console.error("Google Maps Places API not loaded or input not ready");
            return;
        }

        if (!autocompleteRef.current) {
            autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, options);
            autocompleteRef.current.setFields(["formatted_address"]);
        }

        const listener = () => {
            const place = autocompleteRef.current.getPlace();
            if (place && place.formatted_address && onChangeRef.current) {
                onChangeRef.current(place.formatted_address);
                setLastSelectedAddress(place.formatted_address);
            }
        };

        autocompleteRef.current.addListener("place_changed", listener);

        return () => {
            if (autocompleteRef.current) {
                window.google.maps.event.clearListeners(autocompleteRef.current, "place_changed");
            }
        };
    }, [options]);

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={(field, fieldState) => {
                onChangeRef.current = field.onChange;

                const handleBlur = (e) => {
                    field.onBlur();
                    const currentValue = e.target.value.trim();

                    if (lastSelectedAddress !== currentValue) {
                        onChangeRef.current("");
                        setLastSelectedAddress("");
                    }
                };

                return (
                    <TextField
                        {...muiProps}
                        label={muiProps.label}
                        disabled={disabled}
                        error={!!fieldError || fieldState.invalid}
                        helperText={fieldError?.message}
                        value={field.value}
                        onChange={field.onChange}
                        onBlur={handleBlur}
                        inputRef={inputRef}
                        sx={canadaGibsonFont}
                        autoComplete="off"
                    />
                );
            }}
        />
    );
}
